"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsToolbarNavigate = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsLogoIcon = require("../DmsLogoIcon/DmsLogoIcon");
var _material = require("@mui/material");
var _Images = require("../../constants/Images");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _GlobalContext = require("../../context/GlobalContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsToolbarNavigate combines navigation and breadcrumb navigation into a single component.
 * It supports nested Logo and Button sections as children.
 *
 * @component
 * @param {Object} props - The props for the toolbar.
 * @param {React.ReactNode} props.children - The nested content (Logo, Button, etc.).
 * @param {React.ElementType} [props.Logo=DmsLogoIcon] - Customizable logo component.
 * @param {string} [props.logoPath="../img/logo-dms-roxo.png"] - Path to the logo image.
 * @param {number|null} [props.addressPk=1] - Primary key of the address to fetch, or `null` to hide address.
 * @returns {JSX.Element}
 */
const DmsToolbarNavigate = _ref => {
  let {
    children,
    Logo = _DmsLogoIcon.DmsLogoIcon,
    logoPath = _Images.IMAGES.LOGO,
    addressPk = 1
  } = _ref;
  const [address, setAddress] = (0, _react.useState)(addressPk === null ? "" : "-");
  const {
    whoamiReply
  } = (0, _react.useContext)(_GlobalContext.BaseContext);
  (0, _react.useEffect)(() => {
    const fetchAddress = async () => {
      if (addressPk === null) {
        setAddress("");
        return;
      }
      if (whoamiReply) {
        var _whoamiReply$organiza;
        const {
          address,
          number,
          city,
          state,
          country_code
        } = (whoamiReply === null || whoamiReply === void 0 || (_whoamiReply$organiza = whoamiReply.organization_branch) === null || _whoamiReply$organiza === void 0 ? void 0 : _whoamiReply$organiza.address) || {};
        setAddress("".concat(address !== null && address !== void 0 ? address : "-", ", ").concat(number !== null && number !== void 0 ? number : "-", ", ").concat(city !== null && city !== void 0 ? city : "-", ", ").concat(state !== null && state !== void 0 ? state : "-", ", ").concat(country_code !== null && country_code !== void 0 ? country_code : "-"));
      } else {
        const {
          data
        } = await (0, _DmsFetch.fetchData)("/address/".concat(addressPk), "GET", true);
        const {
          address,
          number,
          city,
          state,
          country_code
        } = (data === null || data === void 0 ? void 0 : data.data) || {};
        setAddress("".concat(address !== null && address !== void 0 ? address : "-", ", ").concat(number !== null && number !== void 0 ? number : "-", ", ").concat(city !== null && city !== void 0 ? city : "-", ", ").concat(state !== null && state !== void 0 ? state : "-", ", ").concat(country_code !== null && country_code !== void 0 ? country_code : "-"));
      }
    };
    fetchAddress();
  }, [addressPk, whoamiReply]);
  return /*#__PURE__*/_react.default.createElement(_material.Toolbar, {
    sx: {
      marginTop: 0.5
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    sm: 4
  }, /*#__PURE__*/_react.default.createElement(Logo, {
    logoPath: logoPath,
    isLink: false,
    borderRadius: "0%",
    label: address,
    textColor: "black"
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    sm: 8
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 1,
    justifyContent: "flex-end",
    alignItems: "center"
  }, _react.default.Children.toArray(children).find(child => child.type === DmsToolbarNavigate.Button)))));
};
exports.DmsToolbarNavigate = DmsToolbarNavigate;
DmsToolbarNavigate.Button = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, children);
};